<template>
  <div class="text-center">
    <v-dialog v-model="toggleBonusModal" width="500">
      <v-card id="my-custom-canvas">
        <v-card-text>
          <div class="d-flex align-center justify-center">
            <img
              src="../../assets/images/verified_badge.svg"
              width="114"
              class="my-10"
            />
          </div>

          <div
            class="d-flex align-center justify-center text-center flex-column"
          >
            <p class="modal-title">Congratulations</p>
            <p class="modal-sub-title">
              You have got 300 Covesto Credits as Signup Bonus
            </p>
          </div>

          <div>
            <gamificationCoinVue amount="300" :isProfilePage="false" />
          </div>

          <div class="my-5">
            <p class="caption">
              You can redeem these coins to unlock premium trades or subscribe
              to other paid services
            </p>
          </div>
        </v-card-text>

        <div
          class="d-flex align-center justify-space-between flex-row px-10 py-5"
        >
          <v-btn
            width="203"
            class="px-5 text-none"
            color="primary"
            outlined
            depressed
            @click="closeDialog(false)"
          >
            Skip
          </v-btn>
          <v-btn width="203" class="px-5 text-none" color="primary" depressed>
            Redeem Now
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import VueConfetti from "vue-confetti";
import gamificationCoinVue from "./gamificationCoin.vue";

Vue.use(VueConfetti);
export default {
  name: "bonusCreditModal",
  components: { gamificationCoinVue },

  computed: {
    toggleBonusModal: {
      get() {
        return this.$store.state.gamification.bonusCreditModal;
      },
      set(value) {
        this.$store.commit("SET_BONUS_CREDIT_MODAL", value);
      },
    },
  },
  methods: {
    closeDialog(value) {
      this.$store.commit("gamification/SET_BONUS_CREDIT_MODAL", value); // Close dialog by updating state
    },
  },
  mounted() {
    // this.$confetti.start({
    //   canvasElement: document.getElementById("my-custom-canvas"),
    // });
    // console.log(this.$route)
  },
};
</script>

<style scoped>
.modal-title {
  font-family: Avenir;
  font-size: 38px;
  font-weight: 900;
  line-height: 51.91px;
  text-align: left;
  color: #333333;
}

.modal-sub-title {
  font-family: Avenir;
  font-size: 20px;
  font-weight: 500;
  line-height: 27.32px;
  text-align: center;
  color: #333333;
}

.caption {
  font-family: Avenir;
  font-size: 16px !important;
  font-weight: 500 !important;
  line-height: 21.86px;
  text-align: center;
  color: #333333c2;
}
</style>
